export var valuesAutomaticAssignmentResult = ["Assign", "Remove", "Ignore"];
/*

*/ 
//# sourceMappingURL=AutomaticAssignmentResult.js.map